<template>
	<validationProvider :rules="rules" v-slot="{ errors, valid }" immediate :name="$t('profile.selfIntroduction')">
		<p>
			<FormTitleText :titleText="$t('profile.selfIntroduction')" />
			<RequiredIcon v-if="rules && rules.includes('required')" />
		</p>
		<v-textarea
			v-model="inputedSelfIntroduction"
			:placeholder="selfIntroductionLabel"
			outlined
			background-color="white"
			counter
			:success="valid"
		></v-textarea>
		<FormErrorText :errorText="errors[0]" />
	</validationProvider>
</template>

<script>
import FormTitleText from '../Atoms/FormTitleText'
import FormErrorText from '../Atoms/FormErrorText'
import mypageText from '@/data/mypage/mypageText'
import RequiredIcon from '../Atoms/RequiredIcon'

export default {
	name: 'SelfIntroductionForm',
	components: {
		FormTitleText,
		FormErrorText,
		RequiredIcon
	},
	props: {
		value: {
			type: String,
			required: true
		},
		rules: {
			type: String,
			required: true
		}
	},
	data: () => ({
		selfIntroductionLabel: mypageText.selfIntroductionLabel
	}),
	mounted() {},
	computed: {
		inputedSelfIntroduction: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {}
}
</script>

<style lang="scss" scoped></style>
